export default __webpack_public_path__ + "static/media/staticMap500x700.4c9e7067.png";